export default __webpack_public_path__ + "static/media/enjoyCard3.a5c8448c.webp";